var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8652 7.99969C11.8652 6.62819 11.0702 5.43844 9.91675 4.86719L9.25975 5.52519C10.2743 5.88994 11.0015 6.86144 11.0015 7.99969C11.0015 9.13394 10.28 10.1027 9.27175 10.4712L9.92775 11.1272C11.0752 10.5537 11.8652 9.36769 11.8652 7.99969Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 8C9.875 7.15225 9.1405 6.4655 8.23475 6.4655V0.847C8.23475 0.65525 8.0685 0.5 7.8635 0.5C7.659 0.5 7.49275 0.65525 7.49275 0.847V1.02125C7.222 1.241 3.10775 4.95325 3.10775 4.95325H1.38625C0.89675 4.95325 0.5 5.324 0.5 5.782V10.2172C0.5 10.6755 0.89675 11.0463 1.38625 11.0463H3.108V11.0468C3.108 11.0468 5.51575 12.8877 7.493 14.973V15.1525C7.493 15.3442 7.65925 15.5 7.86375 15.5C8.06875 15.5 8.235 15.3442 8.235 15.1525V9.534C9.14075 9.534 9.875 8.847 9.875 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/Audio.74cb58b4f091b2abfa954c07023e80f9.svg";
export { ForwardRef as ReactComponent };